import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/Login.vue";
import Home from "../components/Home.vue";
import Welcome from "../components/Welcome.vue";
import Users from "../components/user/Users.vue";
import Banners from "../components/banner/Banners.vue";
import NavMenu from "../components/nav/NavMenu.vue";
import Lecturers from "../components/lecturer/Lecturers.vue";
import CourseCategory from "../components/category/CourseCategory.vue";
import Course from "../components/course/Course.vue";
import Roles from "../components/role/Roles.vue";
import Menus from "../components/menu/Menus.vue";
import LoginLog from "../components/log/LoginLog.vue";
import Logs from "../components/log/Logs.vue";
import Attachments from "../components/doc/Attachments.vue";
import University from "../components/university/Universities.vue";
import MajorGroup from "../components/majorGroup/MajorGroup.vue";
import Goods from "../components/goods/Goods.vue";
import Orders from "../components/orders/Orders.vue";
import ActiveCodes from "../components/code/ActivationCode.vue";
import WxUser from "../components/wxUser/WxUser.vue";
import Agent from "../components/wxUser/Agent.vue";
import NotPermission from "../components/401.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },

  {
    path: "/home",
    component: Home,
    meta: { title: "首页" },
    redirect: "/welcome",
    children: [
      {
        path: "/welcome",
        component: Welcome,
      },
      {
        path: "/users",
        component: Users,
        meta: { title: "用户管理" },
      },
      {
        path: "/roles",
        component: Roles,
        meta: { title: "角色管理" },
      },
      {
        path: "/menus",
        component: Menus,
      },
      {
        path: "/loginLog",
        component: LoginLog,
      },
      {
        path: "/logs",
        component: Logs,
      },
      {
        path: "/attachments",
        component: Attachments,
      },
      {
        path: "/banners",
        component: Banners,
      },
      {
        path: "/navMenus",
        component: NavMenu,
      },
      {
        path: "/lecturers",
        component: Lecturers,
      },
      {
        path: "/courseCategories",
        component: CourseCategory,
      },
      {
        path: "/courses",
        component: Course,
      },
      {
        path: "/universities",
        component: University,
      },
      {
        path: "/majorGroup",
        component: MajorGroup,
      },
      {
        path: "/goods",
        component: Goods,
      },
      {
        path: "/orders",
        component: Orders,
      },
      {
        path: "/codes",
        component: ActiveCodes,
      },
      {
        path: "/wxUser",
        component: WxUser,
      },
      {
        path: "/agent",
        component: Agent,
      },
      {
        path: "/401",
        component: NotPermission,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

import store from "../store"; //引入store

//路由导航守卫
router.beforeEach((to, from, next) => {
  const token = window.localStorage.getItem("JWT_TOKEN");
  // 处理登录页
  if (to.path === "/login") {
    // 如果已经在登录页，不做任何操作
    if (from.path === "/login") {
      return next(false); // 取消导航
    }

    if (!token) {
      return next();
    } else {
      // 如果已有token且不在首页，则跳转到首页
      if (from.path !== "/home" && to.path !== "/home") {
        return next({ path: "/home" });
      }
      return next(false);
    }
  }

  // 处理401页面
  if (to.path === "/401") {
    // 如果已经在401页面，不重复跳转
    if (from.path === "/401") {
      return next(false);
    }
    return next();
  }

  if (!token) {
    // 如果当前已经在登录页，不重复跳转
    if (to.path !== "/login") {
      return next("/login");
    }
    return next(false);
  } else {
    const userInfo = store.state.userInfo;
    if (!userInfo) {
      return next("/login");
    }

    if (userInfo.isAdmin) {
      return next();
    } else {
      const urls = userInfo.url;
      if (!Array.isArray(urls)) {
        return next("/401");
      }

      if (urls.indexOf(to.path) > -1) {
        window.sessionStorage.setItem("activePath", to.path);
        return next();
      } else {
        return next("/401");
      }
    }
  }
});

export default router;
